// extracted by mini-css-extract-plugin
export default {"wrapper":"NotesHome_wrapper__a6AxO","link":"NotesHome_link__gmDYM","img":"NotesHome_img__BrJzO"};